import {
  Collapse,
  MenuItem,
  Select,
  TextField,
  FormControlLabel,
  Checkbox,
  ThemeProvider,
  Dialog,
  DialogTitle,
  Button,
  DialogActions,
  DialogContent,
} from "@mui/material";
import React, { useMemo, useRef, useState } from "react";
import palette from "../../../../../../config/colorPalette";
import { clone, isEmpty, isNil } from "ramda";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { handleChannelDisability } from "../utils";
import { getMuiTheme } from "../../../../../utils/utils";
import { MapContainer, Marker, Polyline, TileLayer, useMap } from "react-leaflet";
import { IS_ONLINE, MAP_TYPES } from "../../../../../../config/configmap";

const ChannelInfo = ({
  equipment,
  setEquipment,
  errors,
  setErrors,
  useStyles,
  polylineDisplay,
  indexEquipment,
  indChan,
  channelPK,
  e,
  BootstrapButton,
  susbtructureAsignToggle,
  setSusbtructureAsignToggle,
  susbtructureDataToggle,
  setSusbtructureDataToggle,
  equipmentInterMeasurement,
  setEquipmentInterMeasurement,
  channel,
  channelDataToggle,
  setChannelDataToggle,
  subs,
  inclinometers,
  centroid,
  open,
  customCentroidIcon,
  customInclinometerIcon,
  customShadowIcon,
  customIcon,
  intl,
}) => {
  const theme = useMemo(() => getMuiTheme(), []);
  const [hoveredPolylineIndex, setHoveredPolylineIndex] = useState(null);
  const [mapType] = useState("regular");
  const initializedRef = useRef(false);
  const handleClose = (indexEquipment, indChan, channelDataToggle, setChannelDataToggle) => {
    let newChannel = clone(channelDataToggle);
    if (newChannel[indexEquipment][indChan]) {
      newChannel[indexEquipment][indChan] = false;
    } else {
      initializedRef.current = false;
      newChannel[indexEquipment][indChan] = true;
      for (let indexChannelData = 0; indexChannelData < channelDataToggle[indexEquipment].length; indexChannelData++) {
        if (indexChannelData !== indChan) {
          newChannel[indexEquipment][indexChannelData] = false;
        }
      }
    }

    setChannelDataToggle(newChannel);
  };

  const MyComponentSetView = ({ polyline }) => {
    const map = useMap();
    if (!initializedRef.current && !isEmpty(polyline) && !isNil(polyline[0].points) && !isEmpty(polyline[0].points)) {
      map.fitBounds(polyline[0].points);
      initializedRef.current = true;
    }
    return null;
  };
  return (
    <>
      <Button
        variant="contained"
        style={{ margin: "5%", backgroundColor: palette.secondary, color: "white" }}
        id={`channel${indChan}_collapse`}
        onClick={() => {
          handleClose(indexEquipment, indChan, channelDataToggle, setChannelDataToggle);
        }}
      >
        {intl.formatMessage({ id: "channel" })} {indChan + 1}
      </Button>
      <ThemeProvider theme={theme}>
        <Dialog
          maxWidth="lg"
          open={channelDataToggle[indexEquipment][indChan]}
          onClose={() => handleClose(indexEquipment, indChan, channelDataToggle, setChannelDataToggle)}
        >
          <DialogTitle style={{ fontSize: "x-large", color: palette.primary, fontWeight: "600" }}>
            {intl.formatMessage({ id: "channel" })} {indChan + 1}
          </DialogTitle>
          <DialogContent>
            <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
              <div>
                <TextField
                  id={`channel_name_${indChan}`}
                  style={{ margin: "0.4rem 0.2rem 0.8rem" }}
                  defaultValue={e.channelsNames[indChan]}
                  onChange={(e) => {
                    const newEquipments = [...equipment];
                    const updatedEquipment = { ...newEquipments[indexEquipment] };
                    updatedEquipment.channelsNames[indChan] = e.target.value;
                    newEquipments[indexEquipment] = updatedEquipment;
                    setEquipment(newEquipments);
                  }}
                  error={errors[`channel_name_${indChan}`] ? true : false}
                  variant="outlined"
                  label={intl.formatMessage({ id: "channel.name" })}
                  required
                ></TextField>
                {subs && (
                  <TextField
                    id={`sub_count_${indChan}`}
                    style={{ margin: "0.4rem 0.2rem 0.8rem" }}
                    inputProps={{ min: 1 }}
                    defaultValue={e.channelsSubStructures[indChan].length}
                    onChange={(e) => {
                      const newEquipments = [...equipment];
                      const updatedEquipment = { ...newEquipments[indexEquipment] };
                      const newLength = parseInt(e.target.value);
                      const actualLength = updatedEquipment.channelsSubStructures[indChan].length;
                      if (newLength > actualLength) {
                        for (let i = actualLength; i < newLength; i++) {
                          if (!isEmpty(polylineDisplay)) {
                            updatedEquipment.channelsSubStructures[indChan].push({
                              name: "",
                              type: "generic",
                              section_count: 1,
                              polyline: 1,
                            });
                          } else {
                            updatedEquipment.channelsSubStructures[indChan].push({
                              name: "",
                              type: "inclinometer",
                              section_count: 1,
                              polyline: [0, 0],
                            });
                          }
                        }
                      } else {
                        updatedEquipment.channelsSubStructures[indChan].splice(newLength);
                      }
                      newEquipments[indexEquipment] = updatedEquipment;
                      setEquipment(newEquipments);
                    }}
                    error={errors[`sub_count_${indChan}`] ? true : false}
                    variant="outlined"
                    label={intl.formatMessage({ id: "subs" })}
                    required
                    type="number"
                  ></TextField>
                )}
                <TextField
                  id={`channel_length_${indChan}`}
                  style={{ margin: "0.4rem 0.2rem 0.8rem" }}
                  inputProps={{ min: 0 }}
                  defaultValue={channelPK[indexEquipment][indChan]}
                  value={channelPK[indexEquipment][indChan]}
                  disabled={true}
                  onChange={(e) => {
                    const newEquipments = [...equipment];
                    const updatedEquipment = { ...newEquipments[indexEquipment] };
                    updatedEquipment.channelsLength[indChan] = parseFloat(e.target.value);
                    newEquipments[indexEquipment] = updatedEquipment;
                    setEquipment(newEquipments);
                  }}
                  error={errors[`channel_length_${indChan}`] ? true : false}
                  variant="outlined"
                  label={intl.formatMessage({ id: "channel.length" })}
                  type="number"
                  required
                ></TextField>
                {e.equipmentType !== "DAS" && (
                  <TextField
                    id={`channel_spatial_resolution_${indChan}`}
                    style={{ margin: "0 0.2rem 0.8rem" }}
                    inputProps={{ min: 0 }}
                    defaultValue={0}
                    onChange={(e) => {
                      const newEquipments = [...equipment];
                      const updatedEquipment = { ...newEquipments[indexEquipment] };
                      updatedEquipment.channelsSpatialResolution[indChan] = parseFloat(e.target.value);
                      newEquipments[indexEquipment] = updatedEquipment;
                      setEquipment(newEquipments);
                    }}
                    error={errors[`channel_spatial_resolution_${indChan}`] ? true : false}
                    variant="outlined"
                    label={intl.formatMessage({ id: "channel.spatial.resolution" })}
                    required
                    type="number"
                  ></TextField>
                )}

                <TextField
                  id={`channel_sampling_interval_${indChan}`}
                  style={{ margin: "0 0.2rem 0.8rem" }}
                  inputProps={{ min: 0 }}
                  defaultValue={0}
                  onChange={(e) => {
                    const newEquipments = [...equipment];
                    const updatedEquipment = { ...newEquipments[indexEquipment] };
                    updatedEquipment.channelsSamplingInterval[indChan] = parseFloat(e.target.value);

                    newEquipments[indexEquipment] = updatedEquipment;
                    setEquipment(newEquipments);
                  }}
                  error={errors[`channel_sampling_interval_${indChan}`] ? true : false}
                  variant="outlined"
                  label={intl.formatMessage({ id: "channel.sampling.interval" })}
                  required
                  type="number"
                ></TextField>
                {e.equipmentType !== "DAS" && (
                  <TextField
                    id={`channel_measurement_time_${indChan}`}
                    style={{ margin: "0 0.2rem 0.8rem" }}
                    defaultValue={0}
                    inputProps={{ min: 0 }}
                    onChange={(e) => {
                      const newEquipments = [...equipment];
                      const updatedEquipment = { ...newEquipments[indexEquipment] };
                      updatedEquipment.channelsMeasurementTime[indChan] = parseFloat(e.target.value);
                      const suma = updatedEquipment.channelsMeasurementTime.reduce(
                        (acumulador, valorActual) => acumulador + valorActual,
                        0,
                      );
                      updatedEquipment.measureFrequency = suma;
                      newEquipments[indexEquipment] = updatedEquipment;
                      setEquipment(newEquipments);

                      let newInter = clone(equipmentInterMeasurement);
                      newInter[indexEquipment] = suma;
                      setEquipmentInterMeasurement(newInter);
                    }}
                    error={errors[`channel_measurement_time_${indChan}`] ? true : false}
                    variant="outlined"
                    label={intl.formatMessage({ id: "channel.measurement.time" })}
                    required
                    type="number"
                  ></TextField>
                )}
                {e.equipmentType === "DAS" && (
                  <>
                    <TextField
                      id={`channel_acquisition_frequency_${indChan}`}
                      style={{ margin: "0 0.2rem 0.8rem" }}
                      defaultValue={0}
                      inputProps={{ min: 0 }}
                      onChange={(e) => {
                        const newEquipments = [...equipment];
                        const updatedEquipment = { ...newEquipments[indexEquipment] };
                        updatedEquipment.channelsAcquisitionFrequency[indChan] = parseFloat(e.target.value);

                        newEquipments[indexEquipment] = updatedEquipment;
                        setEquipment(newEquipments);
                      }}
                      error={errors[`channel_acquisition_frequency_${indChan}`] ? true : false}
                      variant="outlined"
                      label={intl.formatMessage({ id: "channel.acquisition.frequency" })}
                      required
                      type="number"
                    ></TextField>{" "}
                    <TextField
                      id={`channel_acquisition_frequency_${indChan}`}
                      style={{ margin: "0 0.2rem 0.8rem" }}
                      defaultValue={0}
                      inputProps={{ min: 0 }}
                      onChange={(e) => {
                        const newEquipments = [...equipment];
                        const updatedEquipment = { ...newEquipments[indexEquipment] };
                        updatedEquipment.channelsGaugeLength[indChan] = parseFloat(e.target.value);

                        newEquipments[indexEquipment] = updatedEquipment;
                        setEquipment(newEquipments);
                      }}
                      error={errors[`channel_acquisition_frequency_${indChan}`] ? true : false}
                      variant="outlined"
                      label={intl.formatMessage({ id: "channel.gauge.length" })}
                      required
                      type="number"
                    ></TextField>
                  </>
                )}
                <FormControlLabel
                  control={
                    <Checkbox
                      id={"checkbox" + indChan}
                      sx={{
                        color: palette.primary,
                        "&.Mui-checked": {
                          color: palette.primary,
                        },
                      }}
                      defaultChecked={e.channelsStates[indChan]}
                      onChange={(e) => {
                        handleChannelDisability({
                          actualID: equipment + indexEquipment + "_frequency",
                          equipment,
                          equipmentInterMeasurement,
                          errors,
                          indChan,
                          indexEquipment,
                          newState: e.target.checked,
                          setEquipment,
                          setEquipmentInterMeasurement,
                          setErrors,
                        });
                      }}
                    />
                  }
                  label={intl.formatMessage({ id: "disable?" })}
                  style={{ marginLeft: "auto" }}
                />
                {e.channelsStates[indChan] ? (
                  <TextField
                    id={`channel_info_${indChan}`}
                    style={{ margin: "0.5rem 0.2rem 0.8rem" }}
                    inputProps={{ min: 0 }}
                    value={e.channelsInfo[indChan]}
                    onChange={(e) => {
                      const newEquipments = [...equipment];
                      const updatedEquipment = { ...newEquipments[indexEquipment] };
                      updatedEquipment.channelsInfo[indChan] = e.target.value;
                      newEquipments[indexEquipment] = updatedEquipment;
                      setEquipment(newEquipments);
                    }}
                    error={errors[`channel_info_${indChan}`] ? true : false}
                    variant="outlined"
                    label={intl.formatMessage({ id: "channel.info" })}
                  />
                ) : null}
                {subs && (
                  <>
                    <BootstrapButton
                      variant="contained"
                      style={{ margin: "0.5rem 0.2rem 0.8rem" }}
                      id="substructures-to-channels"
                      onClick={() => {
                        let newChannel = clone(susbtructureAsignToggle);
                        if (newChannel[indexEquipment][indChan]) {
                          newChannel[indexEquipment][indChan] = false;
                        } else {
                          newChannel[indexEquipment][indChan] = true;
                        }
                        setSusbtructureAsignToggle(newChannel);
                      }}
                    >
                      {intl.formatMessage({ id: "substructures.to.polylines" })}
                      {!susbtructureAsignToggle[indexEquipment][indChan] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                    </BootstrapButton>

                    <Collapse in={susbtructureAsignToggle[indexEquipment][indChan]}>
                      {e.channelsSubStructures[indChan].map((sub, indSub) => {
                        return (
                          <div style={{ margin: "2%", display: "flex", alignItems: "center" }}>
                            <h1
                              style={{ marginRight: "1%" }}
                              id={`sub${indSub}_collapse`}
                              onClick={() => {
                                let newSub = clone(susbtructureDataToggle);
                                if (newSub[indexEquipment][indSub]) {
                                  newSub[indexEquipment][indSub] = false;
                                } else {
                                  newSub[indexEquipment][indSub] = true;
                                  for (
                                    let indexChannelData = 0;
                                    indexChannelData < susbtructureDataToggle[indexEquipment].length;
                                    indexChannelData++
                                  ) {
                                    if (indexChannelData !== indSub) {
                                      newSub[indexEquipment][indexChannelData] = false;
                                    }
                                  }
                                }
                                setSusbtructureDataToggle(newSub);
                              }}
                            >
                              {intl.formatMessage({ id: "sub" })} {indSub + 1}
                              {!susbtructureDataToggle[indexEquipment][indSub] ? (
                                <ArrowDropDownIcon />
                              ) : (
                                <ArrowDropUpIcon />
                              )}
                            </h1>

                            <Collapse in={susbtructureDataToggle[indexEquipment][indSub]}>
                              <TextField
                                id={`sub_name_${indSub}`}
                                style={{ margin: "0 0.2rem 0.8rem", width: "15rem" }}
                                defaultValue={e.channelsSubStructures[indChan][indSub].name}
                                onChange={(e) => {
                                  const newEquipments = [...equipment];
                                  const updatedEquipment = { ...newEquipments[indexEquipment] };
                                  updatedEquipment.channelsSubStructures[indChan][indSub].name = e.target.value;
                                  newEquipments[indexEquipment] = updatedEquipment;
                                  setEquipment(newEquipments);
                                }}
                                error={errors[`sub_name_${indSub}`] ? true : false}
                                variant="outlined"
                                label={intl.formatMessage({ id: "sub.name" })}
                                required
                              />
                              <TextField
                                id={`sub_type_${indSub}`}
                                variant="outlined"
                                style={{ margin: "0 0.2rem 0.8rem", width: "15rem" }}
                                label={intl.formatMessage({ id: "sub.type" })}
                                value={e.channelsSubStructures[indChan][indSub].type}
                                select
                                onChange={(e) => {
                                  const newEquipments = [...equipment];
                                  const updatedEquipment = { ...newEquipments[indexEquipment] };
                                  updatedEquipment.channelsSubStructures[indChan][indSub].type = e.target.value;
                                  const polyNumber = updatedEquipment.channelsSubStructures[indChan][indSub].polyline;
                                  if (e.target.value === "generic" && !Number.isInteger(polyNumber)) {
                                    updatedEquipment.channelsSubStructures[indChan][indSub].polyline = 0;
                                  } else if (e.target.value === "inclinometer" && Number.isInteger(polyNumber)) {
                                    updatedEquipment.channelsSubStructures[indChan][indSub].polyline = [0, 0];
                                  }
                                  newEquipments[indexEquipment] = updatedEquipment;
                                  setEquipment(newEquipments);
                                }}
                                error={errors["measure" + indexEquipment] ? true : false}
                                required
                              >
                                {!isEmpty(polylineDisplay) && (
                                  <MenuItem key={`sub_type_${indSub}_generic`} value={"generic"}>
                                    Generic
                                  </MenuItem>
                                )}
                                <MenuItem key={`sub_type_${indSub}_inclinometer`} value={"inclinometer"}>
                                  Inclinometer
                                </MenuItem>
                              </TextField>
                              <TextField
                                id={`sub_sectioncount_${indSub}`}
                                style={{ margin: "0 0.2rem 0.8rem", width: "15rem" }}
                                defaultValue={e.channelsSubStructures[indChan][indSub].section_count}
                                inputProps={{ min: 1 }}
                                onChange={(e) => {
                                  const newEquipments = [...equipment];
                                  const updatedEquipment = { ...newEquipments[indexEquipment] };
                                  updatedEquipment.channelsSubStructures[indChan][indSub].section_count = parseInt(
                                    e.target.value,
                                  );
                                  newEquipments[indexEquipment] = updatedEquipment;
                                  setEquipment(newEquipments);
                                }}
                                type="number"
                                error={errors[`sub_sectioncount_${indSub}`] ? true : false}
                                variant="outlined"
                                label={intl.formatMessage({ id: "sub.section" })}
                                required
                              ></TextField>
                              <div style={{ margin: "0 0.2rem 0.8rem", display: "inline-block" }}>
                                {e.channelsSubStructures[indChan][indSub].type === "generic" ? (
                                  <Select
                                    id={e.equipmentID + "channel" + indChan}
                                    label={intl.formatMessage({ id: "sub.polyline" })}
                                    onChange={(e) => {
                                      const newEquipments = [...equipment];
                                      const updatedEquipment = { ...newEquipments[indexEquipment] };
                                      updatedEquipment.channelsSubStructures[indChan][indSub].polyline = parseInt(
                                        e.target.value,
                                      );
                                      newEquipments[indexEquipment] = updatedEquipment;
                                      setHoveredPolylineIndex(null);
                                      setEquipment(newEquipments);
                                    }}
                                    defaultValue={e.channelsSubStructures[indChan][indSub].polyline}
                                    onMouseOut={() => {
                                      setHoveredPolylineIndex(null);
                                    }}
                                  >
                                    {polylineDisplay.map((p, indPoly) => {
                                      return (
                                        <MenuItem
                                          key={e.equipmentID + "channel" + indChan + "_" + indPoly}
                                          value={indPoly}
                                          onMouseOver={() => {
                                            setHoveredPolylineIndex(null);
                                            setTimeout(() => {
                                              setHoveredPolylineIndex(indPoly);
                                            }, 0);
                                          }}
                                          onMouseOut={() => {
                                            setHoveredPolylineIndex(null);
                                          }}
                                        >
                                          {indPoly + 1}
                                          {/*                                           <div
                                            className={useStyles.colorSample}
                                            style={{
                                              backgroundColor: "black",
                                              width: "20px",
                                              height: "20px",
                                              display: "inline-block",
                                              marginRight: "8px",
                                              border: "1px solid #ccc",
                                            }}
                                          ></div>*/}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                ) : (
                                  <div style={{ display: "inline" }}>
                                    <TextField
                                      id={`sub_lat_${indSub}`}
                                      style={{ margin: "0 0.2rem 0.8rem", width: "6.5rem" }}
                                      defaultValue={e.channelsSubStructures[indChan][indSub].polyline[0]}
                                      inputProps={{ min: -180, max: 180 }}
                                      onChange={(e) => {
                                        const newEquipments = [...equipment];
                                        const updatedEquipment = {
                                          ...newEquipments[indexEquipment],
                                        };
                                        if (!Number.isNaN(parseFloat(e.target.value)) && !isNil(e.target.value)) {
                                          updatedEquipment.channelsSubStructures[indChan][indSub].polyline[0] =
                                            parseFloat(e.target.value);
                                        }

                                        newEquipments[indexEquipment] = updatedEquipment;
                                        setEquipment(newEquipments);
                                      }}
                                      type="number"
                                      error={errors[`sub_lat_${indSub}`] ? true : false}
                                      variant="outlined"
                                      label={intl.formatMessage({ id: "latitude" })}
                                      required
                                    ></TextField>
                                    <TextField
                                      id={`sub_lon_${indSub}`}
                                      style={{ margin: "0 0.2rem 0.8rem", width: "6.5rem" }}
                                      defaultValue={e.channelsSubStructures[indChan][indSub].polyline[1]}
                                      inputProps={{ min: -180, max: 180 }}
                                      onChange={(e) => {
                                        const newEquipments = [...equipment];
                                        const updatedEquipment = {
                                          ...newEquipments[indexEquipment],
                                        };
                                        if (!Number.isNaN(parseFloat(e.target.value)) && !isNil(e.target.value)) {
                                          updatedEquipment.channelsSubStructures[indChan][indSub].polyline[1] =
                                            parseFloat(e.target.value);
                                        }
                                        newEquipments[indexEquipment] = updatedEquipment;
                                        setEquipment(newEquipments);
                                      }}
                                      type="number"
                                      error={errors[`sub_lon_${indSub}`] ? true : false}
                                      variant="outlined"
                                      label={intl.formatMessage({ id: "longitude" })}
                                      required
                                    ></TextField>
                                  </div>
                                )}
                              </div>
                            </Collapse>
                          </div>
                        );
                      })}
                    </Collapse>
                  </>
                )}
              </div>
              <div>
                <MapContainer
                  id="map-equipment-id"
                  center={[43, 0]}
                  zoom={5}
                  style={{ height: "calc(100vh - 320px)", width: "30vw" }}
                  anima
                >
                  <TileLayer
                    attribution={IS_ONLINE ? "Google Maps" : "OpenStreetMap"}
                    url={MAP_TYPES.find((type) => type.value === mapType).tileLayer}
                    maxZoom={20}
                    subdomains={["mt0", "mt1", "mt2", "mt3"]}
                  />
                  {centroid.length > 0 && (
                    <Marker key={"Centroid"} position={centroid} icon={customCentroidIcon}></Marker>
                  )}
                  <MyComponentSetView polyline={polylineDisplay} />
                  {isNil(hoveredPolylineIndex) &&
                    polylineDisplay.length > 0 &&
                    // eslint-disable-next-line array-callback-return
                    polylineDisplay.map((polyline, index) => {
                      let color = "black";
                      // eslint-disable-next-line array-callback-return
                      return polyline.points.map((point, indice) => {
                        if (indice === 0) {
                          return null;
                        }
                        if (polyline.p_indexes.includes(indice)) {
                          const previousIndex = polyline.p_indexes[polyline.p_indexes.indexOf(indice) - 1];
                          const center = [
                            [
                              polylineDisplay[index].points[previousIndex].lat,
                              polylineDisplay[index].points[previousIndex].lng,
                            ],
                            [point.lat, point.lng],
                          ];
                          for (let indexSub = 0; indexSub < e.channelsSubStructures[indChan].length; indexSub++) {
                            if (index === e.channelsSubStructures[indChan][indexSub].polyline) {
                              color = "red";
                            }
                          }

                          return (
                            <Polyline key={indice + "_" + index} color={color} positions={center} weight={5}></Polyline>
                          );
                        }
                      });
                    })}
                  {!isNil(hoveredPolylineIndex) &&
                    polylineDisplay.length > 0 &&
                    // eslint-disable-next-line array-callback-return
                    polylineDisplay.map((polyline, index) => {
                      let color = "black";
                      // eslint-disable-next-line array-callback-return
                      return polyline.points.map((point, indice) => {
                        if (indice === 0) {
                          return null;
                        }
                        if (polyline.p_indexes.includes(indice)) {
                          const previousIndex = polyline.p_indexes[polyline.p_indexes.indexOf(indice) - 1];
                          const center = [
                            [
                              polylineDisplay[index].points[previousIndex].lat,
                              polylineDisplay[index].points[previousIndex].lng,
                            ],
                            [point.lat, point.lng],
                          ];
                          for (let indexSub = 0; indexSub < e.channelsSubStructures[indChan].length; indexSub++) {
                            if (index === e.channelsSubStructures[indChan][indexSub].polyline) {
                              color = "red";
                            }
                          }
                          return (
                            <Polyline
                              key={indice + "_" + index}
                              color={hoveredPolylineIndex === index ? "#0dff00" : color}
                              positions={center}
                              weight={hoveredPolylineIndex === index ? 9 : 5}
                            ></Polyline>
                          );
                        }
                      });
                    })}
                  {equipment.length > 0 &&
                    equipment.map((equip, index) => (
                      <Marker
                        key={"equipment" + index}
                        position={[equip.latitude, equip.longitude]}
                        icon={open[index] ? customShadowIcon : customIcon}
                      ></Marker>
                    ))}
                  {inclinometers.length > 0 &&
                    inclinometers.map((im, index) => (
                      <Marker key={"inclinometer" + index + im} position={im} icon={customInclinometerIcon}></Marker>
                    ))}
                </MapContainer>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              style={{ backgroundColor: palette.secondary, color: "white" }}
              onClick={() => handleClose(indexEquipment, indChan, channelDataToggle, setChannelDataToggle)}
            >
              {intl.formatMessage({ id: "accept" })}
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    </>
  );
};

export default ChannelInfo;
